import { FC } from "react"
import { TravelersAdd } from "../../../module/travelers/containers/add"

export const TravelersAddPage: FC = () => <TravelersAdd />
